// extracted by mini-css-extract-plugin
export default {"table":"Notice_table__+1ktz","container":"Notice_container__w9DnO"};